import { useState, useEffect } from 'react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: '首页', href: '#hero' },
    { label: '剧集分类', href: '#index' },
    { label: '今日精选', href: '#cards' },
    { label: '热度榜单', href: '#ranking' },
    { label: '热门话题', href: '#topics' },
    { label: 'APP下载', href: '#app' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 flex items-center justify-between h-16">
        <a href="#hero" className="flex items-center gap-2 no-underline group">
          <span className="w-8 h-8 flex items-center justify-center">
            <i className="ri-movie-line text-xl text-primary-500"></i>
          </span>
          <span className="text-lg font-bold font-heading text-foreground-900 whitespace-nowrap group-hover:text-primary-500 transition-colors">
            草民影院
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors rounded-md hover:bg-background-100 whitespace-nowrap"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-b border-background-200/70">
          <ul className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setMobileOpen(false)}
                  className="block px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md transition-colors"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}